import {useEffect} from "react";
import SocketApiService from "../services/SocketApiService";
import {useDispatch} from "react-redux";
import {
    closeWebSocket,
    openWebSocket, recheckAlerts,
    removeAlerts,
    resetAlerts,
    setAlerts, updateAlerts
} from "../store/reducers/webSocketReducer";


export const useConnectSocket = ({reloadOnFocus = false} = {}) => {
    const dispatch = useDispatch()
    const token = localStorage.getItem('token');
    const connectSocket = (token) => {
        SocketApiService.createConnection(token)

        SocketApiService.socket.on('connect', () => {
            console.log("Websocket connected")
            dispatch(openWebSocket())
        })

        SocketApiService.socket.on('disconnect', () => {
            console.log("Websocket disconnected")
            dispatch(closeWebSocket())
            dispatch(resetAlerts())
        })

        SocketApiService.socket.on ('init', (data) => {
            dispatch(setAlerts(JSON.parse(data)))
        })
        SocketApiService.socket.on ('update', (data) => {
            dispatch(updateAlerts(JSON.parse(data)))
        })
        SocketApiService.socket.on('resolve', (data) => {
            dispatch(removeAlerts(JSON.parse(data)))
        })

        SocketApiService.socket.on('force_recheck', (data) => {
            dispatch(recheckAlerts(JSON.parse(data)))
        })
    }
    const closeSocket = () => {
        SocketApiService.closeConnection()
    }

    useEffect(() => {
        connectSocket(token)
        return () => {
            closeSocket()
        }

    }, [token]);

    useEffect(() => {
        if (!reloadOnFocus) {
            return
        }

        function handleWindowFocus() {
            if (!localStorage.getItem('token')) {
                return
            }
            if (SocketApiService.socket && !SocketApiService.socket.connected) {
                console.log("Reloading page...")
                window.location.reload()
            }
        }

        window.addEventListener('focus', handleWindowFocus)
        return () => {
            window.removeEventListener('focus', handleWindowFocus)
        }
    }, [reloadOnFocus])

}
